export const USER_DATA_CHANGE = 'USER_DATA_CHANGE';
export const CHANGE_CURRENT_EMPLOYEE_ID = 'CHANGE_CURRENT_EMPLOYEE_ID';
export const SET_EMPLOYEE_ID = 'SET_EMPLOYEE_ID';
export const CHANGE_EMPLOYEE_DETAILS = 'CHANGE_EMPLOYEE_DETAILS';
export const SET_SELECTED_JOB = 'SET_SELECTED_JOB';
export const SET_SELECTED_CALL = 'SET_SELECTED_CALL';
export const SET_SELECTED_EMPLOYER = 'SET_SELECTED_EMPLOYER';
export const SET_ADD_EMPLOYEE_BASIC_INFO = 'SET_ADD_EMPLOYEE_BASIC_INFO';
export const SET_SELECTED_BULK_CALL = 'SET_SELECTED_BULK_CALL';
export const SET_SELECTED_CLIENT = 'SET_SELECTED_CLIENT';
export const SET_ACTION_FOR_LOG = 'SET_ACTION_FOR_LOG';
export const SET_EDIT_EMPLOYEE_FROM = 'SET_EDIT_EMPLOYEE_FROM';
export const SET_CLIENT_DATA = 'SET_CLIENT_DATA';
export const SET_NOTYFICATION_TYPE = 'SET_NOTYFICATION_TYPE';
export const SET_SELECTED_CALL_LIST = 'SET_SELECTED_CALL_LIST';
export const SET_WISH_LIST_TYPE = 'SET_WISH_LIST_TYPE';
export const SET_LAST_POSITION_ID = 'SET_LAST_POSITION_ID';
export const SET_SELECTED_JOB_FILTER = 'SET_SELECTED_JOB_FILTER';
export const SET_VACATION_LOG_TYPE = 'SET_VACATION_LOG_TYPE';
export const SET_LAST_CALL_ASSIGN_STATUS = 'SET_LAST_CALL_ASSIGN_STATUS';
export const SET_USER_IMAGE = 'SET_USER_IMAGE';
export const SET_LAST_CALENDAR_MONTH = 'SET_LAST_CALENDAR_MONTH';
export const SET_SWITCH_CLIENT = 'SET_SWITCH_CLIENT';

export const SAVE_JOB_DETAILS = 'SAVE_JOB_DETAILS';
export const SAVE_CLIENT_DETAILS = 'SAVE_CLIENT_DETAILS';
export const SAVE_STATUS_LIST = 'SAVE_STATUS_LIST';
export const IS_LOGIN_SUPER = 'IS_LOGIN_SUPER';

//edit-employee-tab
export const SET_EDIT_USER_TAB = 'SET_EDIT_USER_TAB';

// Browser Setting Language mutations
export const BROWSER_SETTINGS_LANGUAGE = 'BROWSER_SETTINGS_LANGUAGE';

//Nylas User Email
export const SET_NYLAS_USER_EMAIL = 'SET_NYLAS_USER_EMAIL';

export const SET_TOKEN_EXPIRY = 'SET_TOKEN_EXPIRY';

export const SET_USER_TOKEN = 'SET_USER_TOKEN';

export const SET_IS_BILLING_EMPLOYEE = 'SET_IS_BILLING_EMPLOYEE';

export const SET_QUERY_PARAM_CLIENT_ID = 'SET_QUERY_PARAM_CLIENT_ID';

export const SET_QUERY_PARAM_APP_SOURCE = 'SET_QUERY_PARAM_APP_SOURCE';

export const SET_ACTING_SUPER = 'SET_ACTING_SUPER';

export const SET_HAS_PENDING_BATCH = 'SET_HAS_PENDING_BATCH';

